<template>
    <svg
        class="icon-hr"
        :class="iconClasses"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="currentColor"
    >
        <path
            d="M12 3H4a1 1 0 0 0-1 1v2.5H2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2.5h-1V4a1 1 0 0 0-1-1M2 9.5h1V12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9.5h1V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm-1.5-2a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1z"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconHr',
    props: {
        size: {
            required: false,
            type: Number,
            default: 4,
        },
        marginAuto: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    computed: {
        iconClasses() {
            const cls = {};
            cls[`h-${this.size} w-${this.size}`] = true;
            cls['m-auto'] = !!this.marginAuto;
            return cls;
        },
    },
};
</script>
